<mat-grid-list cols="5" rowHeight="100px">

</mat-grid-list>
<mat-grid-list cols="5" rowHeight="100px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'orderNo' | translate}}</mat-label>
      <input matInput readonly [(ngModel)]="orderDetails.id">
    </mat-form-field>

  </mat-grid-tile>

  <mat-grid-tile style="margin-left: 10px;">
    <mat-form-field appearance="standard">
      <mat-label>{{'orderType' | translate}}</mat-label>
      <input matInput readonly [(ngModel)]="orderType">
    </mat-form-field>
  </mat-grid-tile>

  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'dateTime' | translate}}</mat-label>
      <input matInput readonly [(ngModel)]="orderDetails.createDate">
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile></mat-grid-tile>

</mat-grid-list>

<!-- ------------------------------------------------------------------ -->
<div *ngIf="orderDetails.serviceClass == 1 && orderDetails.serviceNo == 1">

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile style="margin-left: 10px;">
      <mat-form-field appearance="standard">
        <mat-label>{{'fullName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.fullName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'socialStatus' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.maritalStatus">
      </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'mobileNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>


</div>
<!-- ------------------------------------------------------------------ -->
<div *ngIf="orderDetails.serviceClass == 1 && orderDetails.serviceNo == 2">


  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile style="margin-left: 10px;">
      <mat-form-field appearance="standard">
        <mat-label>{{'firstName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.firstName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'lastName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.lastName">
      </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'idNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.idNo">
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile style="margin-left: 10px;">
      <mat-form-field appearance="standard">
        <mat-label>{{'nationality' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.nationality">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'dob' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.dateOfBirth">
      </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'certfLang' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.certificateLang">
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile style="margin-left: 10px;">
      <mat-form-field appearance="standard">
        <mat-label>{{'certfReason' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.certificatePurpose">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'issuedFrom' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.issuedFrom">
      </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'mobileNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>


</div>
<!-- ------------------------------------------------------------------ -->

<div *ngIf="orderDetails.serviceClass == 1 && orderDetails.serviceNo == 3">

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'universityName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.univercityName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'studentName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.fullName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'paymentNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.paymentNo">
      </mat-form-field>

    </mat-grid-tile>


    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'subscriberNo' | translate}} / {{'referenceNo' | translate}} </mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.referenceNumber">
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

</div>
<!-- ------------------------------------------------------------------ -->
<div *ngIf="orderDetails.serviceClass == 1 && orderDetails.serviceNo == 4">

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'subscriberName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.fullName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'sittingNumber' | translate}} </mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.sittingNumber">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'idNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.idNo">
      </mat-form-field>
    </mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'telNoToConnect' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>

    </mat-grid-tile>


  </mat-grid-list>

</div>
<!-- ------------------------------------------------------------------ -->

<div *ngIf="orderDetails.serviceClass == 1 && orderDetails.serviceNo == 5">

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'idNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.idNo">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'studentName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.fullName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'telNoToConnect' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>

    </mat-grid-tile>

  </mat-grid-list>
</div>

<!-- ------------------------------------------------------------------ -->

<div *ngIf="orderDetails.serviceClass == 1 && orderDetails.serviceNo == 6">

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'studentName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.fullName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'universityName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.univercityName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'paymentNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.paymentNo">
      </mat-form-field>
    </mat-grid-tile>



  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'idNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.idNo">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'subscriberNo' | translate}} / {{'referenceNo' | translate}} </mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.referenceNumber">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'telNoToConnect' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>



    </mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile colspan="3">
      <mat-form-field appearance="standard">
        <mat-label>{{'notes' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.notes">
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

</div>

<!-- ------------------------------------------------------------------ -->
<div *ngIf="orderDetails.serviceClass == 2 && (orderDetails.serviceNo == 1 || orderDetails.serviceNo == 2)">

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'subscriberNo' | translate}} / {{'referenceNo' | translate}} </mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.referenceNumber">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'companyName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.companyName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'subscriberName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.fullName">
      </mat-form-field>
    </mat-grid-tile>




    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'sendReciptTo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>

    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'invoiceAmount' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.paymentValue">
      </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'notes' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.notes">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

</div>
<!-- ------------------------------------------------------------------ -->
<div *ngIf="orderDetails.serviceClass == 2 && orderDetails.serviceNo == 3">

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'subscriberNo' | translate}} / {{'referenceNo' | translate}} </mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.referenceNumber">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'companyName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.companyName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'serviceType' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.serviceType">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'subscriberName' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.fullName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'sendReciptTo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>

    </mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'amount' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.paymentValue">
      </mat-form-field>
    </mat-grid-tile>


    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile colspan="3">
      <mat-form-field appearance="standard">
        <mat-label>{{'notes' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.notes">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>
  </mat-grid-list>



</div>
<!-- ------------------------------------------------------------------ -->
<div *ngIf="orderDetails.serviceClass == 2 && orderDetails.serviceNo == 4">

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'paymentNo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.paymentNo">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'sendReciptTo' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.applicantTel">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile>
      <mat-form-field appearance="standard">
        <mat-label>{{'amount' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.paymentValue">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>

  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile></mat-grid-tile>

    <mat-grid-tile colspan="3">
      <mat-form-field appearance="standard">
        <mat-label>{{'notes' | translate}}</mat-label>
        <input matInput readonly [(ngModel)]="orderDetails.notes">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile></mat-grid-tile>
  </mat-grid-list>


</div>

<div *ngIf="orderDetails.imgUrl != null && orderDetails.imgUrl != ''">

  <mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile>
      <button mat-raised-button color="primary" (click)="viewImage()">
        <mat-icon>add_a_photo</mat-icon>
        {{'viewImage' | translate}}
      </button>
    </mat-grid-tile>
  </mat-grid-list>

</div>

<ng-template #ModalViewImg>

  <!-- <h1 mat-dialog-title>{{'messageText' | translate}}</h1> -->
  <div mat-dialog-content>
    <img src="{{imgPath + orderDetails.imgUrl}}" alt="no image" width="100%" height="100%">
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
  </div>

</ng-template>